<template>
  <form-modal
    :ref="modalName"
    :name="modalName"
    class="NewFeedSource"
    title="Sign up to Newsletter"
    icon="language"
    submit-name="Create"
    full-height
    :submit-disabled="!sourceValidated"
    @submit="submit"
    @[Events.AFTER_CLOSE]="modalClosed"
  >
    <template v-if="currentLandscape">
      <lm-actor-select
        ref="actorSelect"
        :selected-actor="selectedActor"
        check-rights
      >
        Add Newsletter feed to:
      </lm-actor-select>
      <div class="flex items-center">
        <lm-input
          ref="inputUrl"
          class="flex-grow"
          label="Newsletter Url"
          focus
          :maxlength="0"
          @change="checkURL"
        />
        <lm-validator-icon v-if="urlState" :state="urlState" />
      </div>
      <lm-input
        ref="inputTitle"
        label="Title"
        focus
        @submit="submitFromInput"
      />
      <lm-textarea
        ref="inputDescription"
        label="Description (optional)"
        :rows="2"
        :allow-breakline="false"
        @submit="submitFromInput"
      />
      <lm-tags-selector
        ref="tagSelector"
        class="mb-16"
        :options="currentLandscape.tags"
      />
    </template>
  </form-modal>
</template>

<script>
import LmActorSelect from '@/components/form/LmActorSelect'
import {mapGetters} from 'vuex'
import {Events, Modal, FeedSources} from '@/lib/definitions'
import EventHub from '@/lib/eventHub'
import FormModal from '@/components/modals/FormModal'
import LmInput from '@/components/form/LmInput.vue'
import FormHelper from '@/components/form/formHelper'
import LmTextarea from '@/components/form/LmTextarea.vue'
import LmTagsSelector from '@/components/form/LmTagsSelector'
import LmValidatorIcon from '@/components/ui/LmValidatorIcon'
import {urlRegExp} from '@/components/form/editor/mediaHelpers'

export default {
  name: 'ModalNewFeedSource',
  components: {
    LmActorSelect,
    LmValidatorIcon,
    LmTextarea,
    LmTagsSelector,
    FormModal,
    LmInput
  },
  data() {
    return {
      Events,
      FeedSources,
      modalName: Modal.NEWSLETTER_SIGNUP,
      modalRef: null,
      inputs: null,
      tags: [],
      sourceValidated: false,
      urlState: null
    }
  },
  computed: {
    ...mapGetters(['selectedActor', 'currentLandscape'])
  },
  mounted() {
    this.modalRef = this.$refs[this.modalName]
    this.inputs = [
      this.$refs.actorSelect,
      this.$refs.inputUrl,
      this.$refs.inputTitle,
      this.$refs.inputDescription,
      this.$refs.tagSelector
    ]
  },
  methods: {
    checkURL() {
      const url = this.$refs.inputUrl.data
      this.sourceValidated = url && url.match(urlRegExp)
    },
    submitFromInput() {
      this.modalRef.submit()
    },
    submit() {
      console.log(this.inputs, '!!')
      if (FormHelper.validate(this.inputs)) {
        // Set payload
        let payload = {
          actorId: this.$refs.actorSelect.data,
          url: this.$refs.inputUrl.data,
          title: this.$refs.inputTitle.data,
          description: this.$refs.inputDescription.data,
          tags: this.$refs.tagSelector.data,
          includedKeywords: [],
          excludedKeywords: []
        }
        this.$store
          .dispatch('newsletterSignup', payload)
          .then(() => this.modalRef.submitSuccess())
          .catch(error => {
            this.modalRef.submitFails(error.devMessage)
          })
      } else {
        this.modalRef.submitFails()
      }
    },
    modalClosed({fromSubmit}) {
      if (fromSubmit) {
        EventHub.emit(Events.SHOW_SNACKBAR, 'New Source created')
      }
    }
  }
}
</script>
